import { render, staticRenderFns } from "./video-holder.vue?vue&type=template&id=00f3146f&"
import script from "./video-holder.vue?vue&type=script&lang=js&"
export * from "./video-holder.vue?vue&type=script&lang=js&"
import style0 from "./video-holder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports